<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<h2 class="slds-text-heading_small">Burn Down</h2>

<div class=" slds-form_horizontal">
  <div class="slds-form-element">
    <label class="slds-form-element__label" for="project-line" i18n>Project Line</label>
    <div class="slds-form-element__control">
      <div class="slds-select_container" style="max-width: fit-content">
        <select (change)="onProjectLineChange($event)" class="slds-select" id="project-line">
          <option i18n value="">All Lines</option>
          <option *ngFor="let pl of projectLines" [value]="pl.id">{{pl.name}}</option>
        </select>
      </div>
    </div>
  </div>
</div>

<div #chart class="slds-col" id="bd-chart">
</div>

<div *ngIf="showPLineEdit">
  <acc-form (recordChanged)="onRecordChange($event)"
            (saveRecord)="onRecordSave($event)"
            [record]="projectLine"
            [ui]="ui">
  </acc-form>
</div>
